import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { video5KindsOfValue } from '../../../constants/general';

const OrganizationTipContent = ({ onOpenVideo }) => {
  const { t } = useTranslation();
  return (
    <p>
      {t('m1Tip3_1')}
      <button onClick={() => onOpenVideo(video5KindsOfValue)}>{` (${t('link')}).`}</button>
    </p>
  );
};

OrganizationTipContent.propTypes = {
  onOpenVideo: PropTypes.func.isRequired,
};

export default OrganizationTipContent;
